import { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { SLINKY } from 'HubStyleTokens/colors';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import { ChannelLabel } from '../../../capability-editor/public/components';
import { ChannelCapabilitiesConfigContext } from 'conversations-thread-view/channel-capabilities/context/ChannelCapabilitiesConfigContext';
import UIDialogButton from 'UIComponents/dialog/UIDialogButton';
import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { usePopOutEditorState } from '../../../pop-out/public/hooks';
import { useIsPopOutUngated } from '../../../pop-out/protected/hooks';
import { NewFeatureBadge } from '../../../pop-out/public/components';
import { useShepherdDismissState } from '../hooks/useShepherdDismissState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ATTRIBUTE_STORAGE_KEY = `floating-composer-fullscreen-shepherd`;
const Wrapper = styled.div.withConfig({
  displayName: "FloatingComposeEditorWrapper__Wrapper",
  componentId: "sc-14j0zdf-0"
})(["display:flex;flex-direction:column;flex-grow:1;background:white;box-shadow:rgb(0 0 0 / 35%) 0 1px 24px 0;position:relative;border-radius:3px 3px 0 0;width:100%;.DraftEditor-root{min-height:300px !important;}.draft-extend-controls{margin-top:0;}.floating-editor-header{border-radius:3px 3px 0 0;}.floating-editor-header > div{border-radius:3px 3px 0 0;padding-left:25px;min-height:0;height:50px;align-items:center;background-color:", " !important;font-size:1rem;}"], SLINKY);
const GatedChannelLabel = () => {
  const {
    genericChannelId
  } = useContext(ChannelCapabilitiesConfigContext);
  return /*#__PURE__*/_jsx(H2, {
    style: {
      fontSize: '1rem'
    },
    children: /*#__PURE__*/_jsx(ChannelLabel, {
      genericChannelId: genericChannelId
    })
  });
};
GatedChannelLabel.displayName = 'GatedChannelLabel';
export const FloatingComposeEditorWrapper = ({
  children
}) => {
  const {
    close
  } = useFloatingEditorState();
  const isUngated = useIsPopOutUngated();
  const {
    isOpen: isExpanded,
    open: expand,
    close: collapse
  } = usePopOutEditorState('floating');
  const {
    isDismissed,
    setDismissed
  } = useShepherdDismissState({
    attributeKey: ATTRIBUTE_STORAGE_KEY
  });
  const expandAndDismissShepherd = useCallback(() => {
    expand();
    if (!isDismissed) setDismissed();
  }, [expand, setDismissed, isDismissed]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    "data-selenium-test": "popout-composer-editor",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "floating-editor-header",
      children: [/*#__PURE__*/_jsx(GatedChannelLabel, {}), isUngated && !isExpanded && !isDismissed && /*#__PURE__*/_jsx(NewFeatureBadge, {
        className: "m-right-4"
      }), isUngated && /*#__PURE__*/_jsx(UIDialogButton, {
        "aria-label": "expand",
        iconName: isExpanded ? 'exitFullScreen' : 'enlarge',
        className: "m-right-2",
        style: {
          width: '13px'
        },
        onClick: isExpanded ? collapse : expandAndDismissShepherd,
        "data-selenium-test": "expand-popout-composer",
        "data-test-id": "floating-composer-expand-button"
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        style: {
          top: 16,
          width: '13px'
        },
        onClick: close,
        "data-selenium-test": "close-popout-composer"
      })]
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorBoundaryName: "FloatingComposeEditor",
      errorLoggingTitle: "Inbox Floating Compose Editor",
      children: children
    }, "composer-ui")]
  });
};
FloatingComposeEditorWrapper.displayName = 'FloatingComposeEditorWrapper';